export default __webpack_public_path__ + "static/media/FREE.baeb0a00.png";